import moment from "moment";

export const toHourMinutesString = (dateTimeString: string|undefined) => dateTimeString ? moment(dateTimeString).format('HH:mm') : ''
